import * as React from "react";
import type { SVGProps } from "react";
const SvgSparkTotally = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      d="M11 119.518c0 35.817 33.128 40.804 40.064 40.804 6.41 0 12.936-.68 16.936-1.586v-29.924c-3 .454-6.005.906-8.523.906-10.075 0-14.477-4.081-14.477-15.19v-40.96h21v-30H0v30h11zM45 34V0H11z"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);
export default SvgSparkTotally;
